var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRedo = function SvgRedo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.2856C4 8.88564 7.6 5.28564 12 5.28564C14.2 5.28564 16.2 6.28564 18 7.28564L20 5.28564V12.2856L13 12.2856L16 9.28564C15.1 7.98564 13.7 7.28564 12 7.28564C8.7 7.28564 6 9.98564 6 13.2856C6 14.8492 6.6061 16.278 7.59494 17.3488L6.13704 18.7145C4.8124 17.2855 4 15.3758 4 13.2856Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRedo);
export default ForwardRef;